import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import { ReactComponent as BellIcon } from "../../assets/icons/header/bell-main.svg";
import { useGetBadgeNotification } from "modules/Menu/hooks/notification";
import { useEffect } from "react";
import { useSelector } from "react-redux";

interface BellProps {
  notiUnread?: number;
}
const Bell = ({ notiUnread }: BellProps) => {
  console.log("notiUnread", notiUnread);
  const userId = useSelector((state: any) => state.Auth.userInfo?.id);
  const { badgeNotification, fetchBadgeNotification } =
    useGetBadgeNotification();
  useEffect(() => {
    fetchBadgeNotification();
  }, []);
  const navigate = useCustomNavigate();
  const handleGoToList = () => {
    navigate(route(RouterName.NOTIFICATION_LIST));
  };

  console.log(userId, 'userId');
  
  return (
    <button
      className="relative"
      data-testid="cart-badge"
      onClick={handleGoToList}
    >
      <BellIcon />

      {(Number(badgeNotification) > 0 && userId) && (
        <span
          className={`absolute 
        text-[11px] 
        top-[-5px] 
        right-[-5px] 
        bg-[#FF6741] 
        text-white 
        rounded-full 
        flex 
        items-center 
        justify-center
        w-4 h-[17px]
        ${
          Number(badgeNotification) > 99 ? " text-[9px] tracking-tighter" : ""
        }       
        `}
        >
          {Number(badgeNotification) > 99 ? "99+" : badgeNotification}
        </span>
      )}
    </button>
  );
};

export default Bell;
